import { Component, OnInit, DoCheck } from '@angular/core';
import { Constants } from '../../shared/Helpers/constants';
import { SharedService } from '../../shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TwoFAService, UserService } from '../../_services';
import { forkJoin } from 'rxjs';
import { ISmsAuthenticatorPatch, IUser2FAConfiguration } from 'src/app/shared/interfaces';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';

@Component({
  moduleId: module.id,
  templateUrl: './twoFA-login-authentication.component.html'
})
export class TwoFALoginAuthenticationComponent implements OnInit, DoCheck {
  public logoPath: any;
  public viewToDisplay: string;
  public twoFAMethod: string;
  public methodsSetup: string;
  public smsEnabled: boolean;
  public userConfig: IUser2FAConfiguration
  public pendingAppState: boolean;
  private sendCodeOnInit: boolean;
  public removeLogo: boolean = false;

  constructor(
    public sharedService: SharedService,
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserService,
    public twoFAService: TwoFAService
  ) {
    this.sendCodeOnInit = route.snapshot.queryParams['sendCode'] == 'true' ? true : false;
  }

  ngOnInit() {
    this.checkIfUserLoggedIn();
    this.checkIfError();
  }

  changeView(view: string) {
    this.viewToDisplay = view;
  }

  checkIfError() {
    if (this.sharedService.errorMsg.value) {
      Alert.basicNotification(AlertTypeEnum.Error, "", this.sharedService.errorMsg.value);
    }
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        }
        else {
          this.logoPath = Constants.logoPath;
        }
      }
      else {
        this.logoPath = Constants.logoPath;
      }
    }
    else {
      this.logoPath = Constants.logoPath;
    }
  }

  public checkIfUserLoggedIn() {
    if (this.sharedService.currentOrganisationId.value == null || this.sharedService.loggedUserId.value == null) {
      this.router.navigateByUrl('/login');
    }
    else {
      this.getUsefulData();
    }
  }

  private getUsefulData() {
    const smsConf = this.userService.getSmsEnabled(this.sharedService.currentOrganisationId.value);
    const userConf =  this.twoFAService.getUser2FAConfiguration(this.sharedService.currentOrganisationId.value, this.sharedService.loggedUserId.value);
    forkJoin([smsConf, userConf]).subscribe( (resp: any) => {
      if (resp[0].body) {
        this.smsEnabled = resp[0].body;
      }
      if (resp[1].body) {
        this.userConfig = resp[1].body;
        if (this.sendCodeOnInit) {
          this.sendCode('APP')
        }
        else {
          this.customizeView();
        }
      }
    })
  }

  public checkMethodsSetUp() {
    this.twoFAService.getUser2FAConfiguration(this.sharedService.currentOrganisationId.value, this.sharedService.loggedUserId.value).subscribe(resp => {
      this.userConfig = resp.body;
      this.customizeView();
    })
  }

  private customizeView() {
    this.changeView('authenticate');
  }

  public changedPhoneAndSendCode(mobileNumber: string) {
    if (mobileNumber) {
      if (this.userConfig.smsAuthenticator && mobileNumber != this.userConfig.smsAuthenticator.phoneNumber) {
        this.changeSmsConfig(mobileNumber);
      }
      else {
        this.sendCode('SMS');
      }
    }
  }

  private changeSmsConfig(mobileNumber: string) {
    const smsAuthenticatoPatchDto: ISmsAuthenticatorPatch = {
      phoneNumber: mobileNumber,
      version: 0
    }
    this.twoFAService.changeSmsConfiguration(this.sharedService.currentOrganisationId.value, this.sharedService.loggedUserId.value, this.userConfig.id, smsAuthenticatoPatchDto)
      .subscribe({
        next: (res) => {
          this.userConfig = res.body;
          this.sendCode('SMS');
        },
        error: (err) => {
          if (err?.error?.errorCode === 1000) {
            Alert.basicNotification(AlertTypeEnum.Error, "", err.error.detailedMessage);
          }
        }
    });
  }

  private sendCode(viaMethod = 'SMS') {
    this.twoFAService.resend2FACode(this.sharedService.currentOrganisationId.value, this.sharedService.loggedUserId.value, viaMethod).subscribe({
      next: () => {
        // userConfig object needs to be refreshed
        // TODO: try to avoid this
        this.checkMethodsSetUp();
        this.changeView('authenticate');
      },
      error: (err) => {
        let msg = err.error.detailedMessage;
        if (msg.indexOf('for user') > 0) {
          msg = msg.substr(0, msg.indexOf('for user'))
        }
        Alert.basicNotification(AlertTypeEnum.Error, "", msg);
        this.changeView('authenticate');
      }
    })
  }

  public onMethodSwitched() {
    // userConfig object needs to be refreshed
    // TODO: try to avoid this
    this.checkMethodsSetUp();
  }

  public changePhoneNo() {
    this.changeView('smsAuthentication')
  }

  public removeLogoFromView(view: boolean | any) {
    this.removeLogo = view;
  }

  public changeDevice() {
    this.router.navigate(['/2FA-setup'], {queryParams: {setup: 'change device'}})
  }

  public sendVerificationCode() {
    this.sendCode('APP');
  }

  public showDeviceConfirmPage() {
    this.changeView('deviceConfirmed');
  }
}
